import appStore from './appStore'
import thresholdRuleStore from '../routes/AlertRules/store'
import metricStore from '../routes/Metrics/store'
import userStore from '../routes/Subscription/store'
import unhandledAlertStore from '../routes/Alert/unhandled-alerts/store'
import handledAlertStore from '../routes/Alert/handled-alerts/store'
import dashboardStore from '../routes/MonitorDashBoard/store'


const store = {
  dashboardStore,
  unhandledAlertStore,
  handledAlertStore,
  appStore,
  thresholdRuleStore,
  metricStore,
  userStore
}
export default store


// WEBPACK FOOTER //
// ./src/store/index.js